export default __webpack_public_path__ + "static/media/sunglasses.f52400ef.png";